
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LoginForm extends Vue {
  @Prop() private usernameLogin!: false;
  @Prop() private loading!: false;

  private showPassword = false;
  private user = { email: '', password: '' };
}
